import pcURL from '@planningcenter/url';
import { useState, useCallback, useEffect } from 'react';
import apiRequest, { defaultFetch } from '../../../../chat-core/api_request.js';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../../_virtual/moment.js';
import { useChat } from '../../../hooks/use_chat.js';
import '../../../chat_api_context.js';
import '@planningcenter/jolt-client';
import 'stream-chat';

function useMyGroups(shouldRunInitialLoad) {
    const { env } = useChat();
    const url = `${pcURL(env)("api")}/groups/v2/me/groups`;
    const params = new URLSearchParams({
        "fields[Group]": "name,header_image,memberships_count,can_create_conversation",
        per_page: "100",
    });
    const [nextLink, setNextLink] = useState(`${url}?${params}`);
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const hasMore = Boolean(nextLink);
    const loadGroups = useCallback(() => {
        if (!hasMore)
            return;
        setIsLoading(true);
        apiRequest(defaultFetch, nextLink)
            .then(({ json }) => {
            const results = json.data.map((result) => ({
                canCreateConversation: result.attributes.can_create_conversation,
                headerImage: result.attributes.header_image,
                id: result.id,
                membershipsCount: result.attributes.memberships_count,
                name: result.attributes.name,
            }));
            setGroups((prev) => [...prev, ...results]);
            setNextLink(json.links.next || null);
        })
            .catch(() => setIsError(true))
            .finally(() => setIsLoading(false));
    }, [nextLink]);
    useEffect(() => {
        if (!shouldRunInitialLoad)
            return;
        loadGroups();
    }, [shouldRunInitialLoad]);
    return { groups, hasMore, isError, isLoading, loadMore: loadGroups };
}

export { useMyGroups };
//# sourceMappingURL=use_my_groups.js.map
